import Faq from "../components/subComponents/Faq"
import Header from "../components/mainComponents/Header"
import MainFooter from "../components/mainComponents/MainFooter"

const RulesAndFaq = () => {
  return (
    <div className="min-h-screen">
    <Header />
    <Faq />
    <MainFooter />
    </div>
  )
}

export default RulesAndFaq
